import { type RefObject, useEffect } from 'react'

/**
 * Hook to detect clicks outside an element.
 *
 * @param ref
 * @param handler
 */
export function useOnClickOutside(
  ref: RefObject<HTMLElement | null>,
  handler: ((event: MouseEvent | TouchEvent) => unknown) | undefined | null,
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return
      }

      handler?.(event)
    }

    if (handler) {
      document.addEventListener('click', listener, { capture: true })
    }

    return () => {
      document.removeEventListener('click', listener, { capture: true })
    }
  }, [handler, ref])
}
